'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RuTube = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var RuTube = exports.RuTube = function (_Component) {
  _inherits(RuTube, _Component);

  function RuTube() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RuTube);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RuTube.__proto__ || Object.getPrototypeOf(RuTube)).call.apply(_ref, [this].concat(args))), _this), _this.ref = function (iframe) {
      _this.iframe = iframe;

      _this.props.onReady();
    }, _this.load = function () {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RuTube, [{
    key: 'play',
    value: function play() {
      this.iframe.contentWindow.postMessage(JSON.stringify({
        type: 'player:play',
        data: {}
      }), '*'); //this.callPlayer('play')
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.iframe.contentWindow.postMessage(JSON.stringify({
        type: 'player:pause',
        data: {}
      }), '*'); //this.callPlayer('pause')
    }
  }, {
    key: 'stop',
    value: function stop() {// Nothing to do
    }
  }, {
    key: 'seekTo',
    value: function seekTo(seconds) {//this.callPlayer('seekTo', seconds * 1000)
    }
  }, {
    key: 'setVolume',
    value: function setVolume(fraction) {// this.callPlayer('setVolume', fraction * 100)
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {//return this.duration
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {// return this.currentTime
    }
  }, {
    key: 'getSecondsLoaded',
    value: function getSecondsLoaded() {
      return this.fractionLoaded * this.duration;
    }
  }, {
    key: 'render',
    value: function render() {
      var result = this.props.url.split('/video/');
      var url = result[1].replace('/', '');

      var style = _extends({
        width: '100%',
        height: '100%'
      }, this.props.style);

      return _react2['default'].createElement('iframe', {
        ref: this.ref,
        src: 'https://rutube.ru/play/embed/' + url + '?autoStart=true',
        style: style,
        frameBorder: 0
      });
    }
  }]);

  return RuTube;
}(_react.Component);

RuTube.displayName = 'SoundCloud';

RuTube.canPlay = function (url) {
  return url.startsWith('https://rutube.ru');
};